
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';

import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { StyleEngine } from '../../../manager/workingdata/style.engine';
import { ScenarioVO } from '../../../vo/scenarii/scenario.vo';

/**
 * rendu de la pop de confirmation
 */
@Component({
  selector: 'scen-pop-renderer',
  templateUrl: './scen-pop.renderer.html',
  styles: [':host {max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * Renderer des actions sur un modèle de codification dans le grid
 */
export class ScenPopRenderer implements AgRendererComponent {
  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  scen: ScenarioVO = null;
  code: string = '';
  trsLabel: string = '';
  color: string = StyleEngine.STYLE_DEFAULT_SCEN_COLOR;

  refresh(params: ICellRendererParams): boolean {
    this.scen = params.data;
    this.code = this.scen.code;
    this.trsLabel = this.scen.trsLabel;
    this.color = this.scen.color;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.scen = params.data;
    this.code = this.scen.code;
    this.trsLabel = this.scen.trsLabel;
    this.color = this.scen.color;
    this.cdref.markForCheck();
  }
}
